module.exports = __webpack_public_path__ + "img/Airbnb-Productivity-Move-Your-Body.c2985ce3.jpg";